import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { start as startTheme } from './lib/theme';
import { read as readPreferences, applyMotion } from './lib/preferences';
import './assets/tokens.css';
import './assets/style.css';

// Antes de montar: pintar o tema depois do primeiro quadro faz a tela piscar no escuro
// para quem escolheu claro.
startTheme();
applyMotion(readPreferences().reducedMotion);

createApp(App).use(store).use(router).mount('#app');
